var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('participation-view-content-container',{attrs:{"current-stage":_vm.currentStage}},[_c('terms-and-conditions-acceptance'),_c('terms-and-conditions-navigation-navbar',{staticClass:"float-bottom-navbar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }